import { IconApps, IconAlertTriangle, IconShieldLock, IconUsers } from "@tabler/icons-react";

export const data = {
  label: "My Dashboard",
  description: "Your central control room",
  avatar: null,
  sections: [
    {
      label: "Dashboard",
      items: [
        {
          label: "Admin panel",
          href: "/admin-panel",
          icon: IconApps,
          danger: false,
        },
      ],
    },
    {
      label: "Sentry",
      items: [
        {
          label: "Sentry test",
          description: "Simulate an error for testing",
          href: "/admin-panel/sentry",
          icon: IconAlertTriangle,
          danger: false,
        },
        {
          label: "Analytics",
          description: "Security metrics & activity logs",
          href: "/admin-panel/analytics",
          icon: IconShieldLock,
          danger: false,
        },
        {
          label: "Users",
          description: "Manage access and roles",
          href: "/admin-panel/users",
          icon: IconUsers,
          danger: false,
        },
      ],
    },
  ],
};
